import { HTMLProps, useEffect, useRef } from 'react';

interface Props extends HTMLProps<HTMLButtonElement> {
  type?: 'button' | 'submit' | 'reset' | undefined;
  initialDelay?: number;
  delay?: number;
  onClick?: () => void;
}

export default function HoldButton({
  children,
  onClick,
  initialDelay = 500,
  delay = 50,
  ...rest
}: Props) {
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const onClickRef = useRef<typeof onClick>(onClick);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    onClickRef.current = onClick;
  }, [onClick]);

  function repeat() {
    onClickRef.current && onClickRef.current();
    timeoutRef.current = setTimeout(() => repeat(), delay);
  }

  function onMouseDown() {
    onClickRef.current && onClickRef.current();
    timeoutRef.current = setTimeout(() => repeat(), initialDelay);
    document.addEventListener('mouseup', onMouseUp);
  }

  function onTouchStart() {
    onClickRef.current && onClickRef.current();
    timeoutRef.current = setTimeout(() => repeat(), initialDelay);
    document.addEventListener('touchend', onTouchEnd);
  }

  function onMouseUp() {
    onEndHold();
    document.removeEventListener('mouseup', onMouseUp);
  }

  function onTouchEnd() {
    onEndHold();
    document.removeEventListener('touchend', onMouseUp);
  }

  function onEndHold() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  return (
    <button {...rest} onMouseDown={onMouseDown} onTouchStart={onTouchStart}>
      {children}
    </button>
  );
}
